import { Button, Box } from "@mui/material";
import { Plus } from "lucide-react";

interface AddBtnProps {
    onClick: () => void;
    disabled?: boolean;
    label: string;
}

const AddBtn: React.FC<AddBtnProps> = ({ onClick, disabled, label }) => {
    return (
        <Button
            variant="contained"
            color="primary"
            disabled={disabled}
            onClick={() => onClick()}
            sx={{
                color: '#fff', 
                backgroundColor: 'var(--color-primary)', 
                display: 'flex', 
                alignItems: 'center', 
                gap: 1,
                '&:hover': { backgroundColor: 'var(--color-primary)' } 
            }}
        >
            <Box sx={{ 
                width: 20, 
                height: 20, 
                borderRadius: '50%', 
                background: 'var(--color-page-background)', 
                display: 'flex', 
                alignItems: 'center', 
                justifyContent: 'center' }}
            >
                <Plus size={16} color="var(--color-primary)"/>
            </Box>
            {label}
        </Button>
    );
}
export default AddBtn;